const CARTSTATE_MODULE_DATA = {
  contentData: {
    modalContent: {
      unavailableText: {
        contentText: 'unavailableCartText',
        contentMain: 'unavailableCartMain',
        cartQuery: 'unavailableCartQuery',
      },
      priceChangeText: {
        contentText: 'priceChangedCartText',
        contentMain: 'priceChangedCartMain',
        cartQuery: 'priceChangedCartQuery',
      },
      bothChangeText: {
        contentText: 'bothChangeCartText',
        contentMain: 'bothChangeCartMain',
        cartQuery: 'bothChangeCartQuery',
      },
      infoObject: {
        type: 'info',
        infoText: 'cartInfoText',
      },
      discardbuttonTypes: {
        buttonText: 'discardChanges',
        selectDefault: false,
        type: 'discardChanges',
      },
      confirmButtonTypes: {
        buttonText: 'confirmChanges',
        selectDefault: false,
        type: 'confirmChanges',
      },
    },
  },
};

export default CARTSTATE_MODULE_DATA;
